import React from 'react';
import { FaStar } from 'react-icons/fa';

const AboutProject = () => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-800">About Project</h2>
        <a href="#" className="text-[#d8232a] text-sm font-semibold flex items-center hover:underline">
          Explore Project <span className="ml-1">→</span>
        </a>
      </div>

      {/* Main Details Section */}
      <div className="flex items-start space-x-6 mb-6">
        {/* Project Image */}
        <img
          src="https://img.staticmb.com/mbimages/project/Photo_h100_w150/2022/02/07/Project-Photo-15-Unique-Sapphire-Jaipur-5091764_345_1366_100_150.jpg"
          alt="Project Thumbnail"
          className="w-24 h-24 rounded-md"
        />

        {/* Project Info and Metrics */}
        <div className="flex-1">
          <div className="flex space-x-3">
            {/* Project Info */}
            <div>
              <h3 className="text-[16px] font-semibold text-[#303030]">Unique Sapphire</h3>
              <p className="text-base text-[#606060] font-normal">by Unique Builders</p>
              <div className="flex items-center mt-2">
                <span className="mr-2">4.9</span>
                <div className="flex text-yellow-400">
                  {[...Array(5)].map((_, index) => (
                    <FaStar key={index} />
                  ))}
                </div>
                <span className="text-[#606060] text-sm ml-2 font-normal">4 Reviews</span>
              </div>
            </div>

            {/* Project Metrics */}
            <div className="flex items-start space-x-3">
              {/* Vertical Line */}
              <div className="border-l border-gray-300 h-[55px]"></div>
              <div>
                <span className="text-[#606060]">Price</span>
                <p className="font-semibold text-[#303030] text-sm">Call For Price</p>
              </div>

              {/* Vertical Line */}
              <div className="border-l border-gray-300 h-[55px]"></div>
              <div>
                <span className="text-[#606060]">Price per sqft</span>
                <p className="font-semibold  text-[#303030] text-sm">₹ 3,504 - ₹ 3,932</p>
              </div>

              {/* Vertical Line */}
              <div className="border-l border-gray-300 h-[55px]"></div>
              <div>
                <span className="text-[#606060]">Configuration</span>
                <p className="font-semibold  text-[#303030] text-sm">2, 3 BHK Flats</p>
              </div>

              {/* Vertical Line */}
              <div className="border-l border-gray-300 h-[55px]"></div>
              <div>
                <span className="text-[#606060]">Tower & Unit</span>
                <p className="font-semibold text-[#303030] text-sm">4 Towers, 243 Units</p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex space-x-4 mt-4">
            <button className="bg-white border border-gray-300 px-4 py-2 rounded-full text-[#303030] font-semibold hover:bg-gray-100 text-[14px] h-[32px] flex justify-center items-center">
              Download Brochure
            </button>
            <button className="bg-white border border-gray-300 px-4 py-2 rounded-full text-[#303030] font-semibold hover:bg-gray-100 text-[14px] h-[32px] flex justify-center items-center">
              Follow Project
            </button>
            <button className="bg-white border border-gray-300 px-4 py-2 rounded-full text-[#303030] font-semibold hover:bg-gray-100 text-[14px] h-[32px] flex justify-center items-center">
              Compare Projects
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutProject;
